/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2021. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createReducer, on } from '@ngrx/store';

import { GlobalConfigActions } from '@settings/store/actions';
import { GlobalPriceConfiguration } from '@core/models';
export const GLOBAL_CONFIG_FEATURE_KEY = 'global-config';

export interface GlobalConfigState {
  globalConfigs: GlobalPriceConfiguration[];
  isLoading: boolean;
  isUpdating: boolean;
  errorMessage: string;
}

const initialState: GlobalConfigState = {
  globalConfigs: null,
  isLoading: false,
  isUpdating: false,
  errorMessage: '',
} as any;

export const globalConfigReducer = createReducer(
  initialState,
  on(GlobalConfigActions.loadGlobalConfig, GlobalConfigActions.batchUpdateGlobalConfigs, (state) => ({
    ...state,
    isLoading: true,
  })),

  on(GlobalConfigActions.updateGlobalConfig, (state) => ({
    ...state,
    isUpdating: true,
  })),

  on(GlobalConfigActions.loadGlobalConfigSuccess, (state, { globalConfigs }) => ({
    ...state,
    globalConfigs,
    isLoading: false,
  })),

  on(GlobalConfigActions.updateGlobalConfigSuccess, (state, { config }) => ({
    ...state,
    globalConfigs: state.globalConfigs.map((c) => (c.id === config.id ? config : c)),
    isUpdating: false,
  })),

  on(GlobalConfigActions.batchUpdateGlobalConfigsSuccess, (state, { configs }) => ({
    ...state,
    globalConfigs: state.globalConfigs.map((c) => {
      const found = configs.find((c1) => c.id === c1.id);
      return found ? { ...c, ...found } : c;
    }),
    isLoading: false,
  })),

  on(GlobalConfigActions.loadGlobalConfigFailure, GlobalConfigActions.batchUpdateGlobalConfigsFailure, (state) => ({
    ...state,
    isLoading: false,
  })),

  on(GlobalConfigActions.updateGlobalConfigFailure, (state, { errorMessage }) => ({
    ...state,
    errorMessage,
    isUpdating: false,
  })),

  on(GlobalConfigActions.deleteGlobalConfigSuccess, (state, { id }) => ({
    ...state,
    globalConfigs: state.globalConfigs.filter((gc) => gc.id !== id),
    isLoading: false,
  })),

  on(GlobalConfigActions.addGlobalConfigSuccess, (state, { globalConfig }) => ({
    ...state,
    globalConfigs: [...state.globalConfigs, globalConfig],
    isLoading: false,
  })),

  on(GlobalConfigActions.updatePriceTypeSuccess, (state, { priceType, updatedBy }) => ({
    ...state,
    globalConfigs: state.globalConfigs.map((gc) =>
      gc.id === priceType.globalPriceConfigurationId
        ? {
            ...gc,
            updatedBy,
            updatedAt: new Date(),
            globalPriceConfigurationPriceTypes: gc.globalPriceConfigurationPriceTypes.map((p) =>
              p.id === priceType.id ? priceType : p
            ),
          }
        : gc
    ),
    isLoading: false,
  })),

  on(GlobalConfigActions.updateSelectedPriceTypesSucccess, (state, { priceTypes, updatedBy }) => ({
    ...state,
    globalConfigs: state.globalConfigs.map((gc) => {
      const updated = priceTypes.find((priceType) => gc.id === priceType.globalPriceConfigurationId);
      return updated
        ? {
            ...gc,
            updatedBy,
            updatedAt: new Date(),
            globalPriceConfigurationPriceTypes: priceTypes,
          }
        : gc;
    }),

    isLoading: false,
  }))
);
